import styled from 'styled-components';

export const SubmissionModeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
